import { openLink } from '@telegram-apps/sdk';
import { useCallback, useEffect } from 'react';

import { Spinner } from '~/shared/ui/Spinner/Spinner';

import { useLocalization } from '../../../../localization/localization';
import { SbpButton } from '../../SbpButton/SbpButton';

import {
  ButtonWrapper,
  Content,
  Description,
  LoaderWrapper,
  Root,
  Title,
} from './RedirectStep.ui';

export const RedirectStep = ({ url }: { url: string }) => {
  const { t } = useLocalization();

  const handleRedirect = useCallback(() => {
    openLink(url);
  }, [url]);

  useEffect(() => {
    if (url) {
      handleRedirect();
    }
  }, [handleRedirect, url]);

  return (
    <Root>
      <Content>
        <LoaderWrapper>
          <Spinner size={48} />
        </LoaderWrapper>
        <Title>{t('redirect title')}</Title>
        <Description>{t('redirect description')}</Description>
      </Content>
      <ButtonWrapper>
        <SbpButton onClick={handleRedirect}>{t('redirect button')}</SbpButton>
      </ButtonWrapper>
    </Root>
  );
};
